module.exports = __webpack_public_path__ + "static/media/lock_glyph8.3d2a58a2.svg";